import React from "react";
import { FormFieldLabel } from "../../../atoms/proc-management/form";
import { getMaxLength } from "../../../../application/domain/proc-management/util/input-max-length";
import { InputNoticeList } from "./input-notice-list";
import { SimpleTextAreaInput } from "./simple-textarea-input";
import type { InputProps, PathProps } from "./types";

const notices = [
  "手続き全体について、簡潔な要約を記述します。ページを訪れたユーザーがどのような手続きかを一目で理解できるようにします。",
  "例: サンプル市から他の市区町村や国外に引越しをされる方が必要な、「転出」の届け出についてのページです。",
];

type Props = InputProps & PathProps & { value: string; errorMsg?: string };

export const ProcedureSummaryInput: React.FC<Props> = ({
  onChange,
  disabled = false,
  basePath,
  value,
  shouldDisplayError,
  errorMsg,
}) => {
  return (
    <div className="field mb-6">
      <FormFieldLabel label="手続き概要説明" required />
      <InputNoticeList notices={notices} />
      <SimpleTextAreaInput
        onChange={onChange}
        basePath={basePath}
        value={value}
        disabled={disabled}
        shouldDisplayError={shouldDisplayError}
        errorMsg={errorMsg}
        maxLength={getMaxLength("procSummary")}
      />
    </div>
  );
};
